import {
    selectCurrentProject,
    selectProjectArea
} from "@features/project/projectSlice"
import { useAppSelector } from "@app/hooks"
import { useEffect, useRef } from "react";
import { useUploadMapDataMutation } from "@app/hooks/useProjectHooks";
import { Feature, FeatureCollection, isFeature, isFeatureCollection } from "@components/actions/map/mapMessages";

/**
 * SCENARIOS
 * If exact map is set and b-intact is not: The first time we open the b-intact builder we want to load the exact map data
 * If b-intact map is set and exact map is not: we want to align the exact map data with the b-intact map data and disable the exact map buttons
 * If both are set: we want to keep them aligned
 */

export const useSynchronizeMapData = () => {
    const [uploadMapData] = useUploadMapDataMutation();
    const { project } = useAppSelector(selectCurrentProject);
    const bIntactMapData = useAppSelector(selectProjectArea);

    const isSyncingRef = useRef(false);

    useEffect(() => {
        if (!project || !bIntactMapData) return;

        let payload: FeatureCollection | Feature;
        if (isFeatureCollection(bIntactMapData)) {
            payload = bIntactMapData;
        } else if (isFeature(bIntactMapData)) {
            payload = {
                type: "FeatureCollection",
                features: [bIntactMapData],
            };
        } else {
            return;
        }

        const nextPayload = JSON.stringify(payload);

        // Prevent unnecessary updates
        if (project.map_data === nextPayload) return;
        if (isSyncingRef.current) return;

        isSyncingRef.current = true;
        uploadMapData({
            projectId: project.id,
            mapData: nextPayload,
        }).finally(() => {
            isSyncingRef.current = false;
        });

    }, [project?.id, project?.map_data, bIntactMapData])
}